import { useMutation, useQueryClient } from '@tanstack/react-query';

import { expectStatus } from '@/lib/api/client';
import { removeTaskAttachment } from '@/lib/api/generated/api';
import { taskKeys } from '../queryKeys';

/** Delete one attachment from the task's folder (spec 120 FR-008). */
export function useRemoveTaskAttachment(workspaceId: string, taskId: string) {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (name: string) =>
      expectStatus(
        await removeTaskAttachment(workspaceId, taskId, name),
        204,
        `${name} could not be removed.`,
      ),
    onSettled: () =>
      queryClient.invalidateQueries({
        queryKey: taskKeys.attachments(workspaceId, taskId),
      }),
  });
}
